export const getItemNumberInterval = (
  searchResultCount: number,
  itemsPerPage: number,
  pageNumber?: number
) => {
  if (searchResultCount <= itemsPerPage || !pageNumber) return `${searchResultCount}`
  const end = Math.min(pageNumber * itemsPerPage, searchResultCount)
  const start = (pageNumber - 1) * itemsPerPage + 1
  return `${start}-${end}`
}
